/***********************************
  Home Module
************************************/

Quad.Home = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    if ( $( 'body' ).hasClass( 'page-template-homepage' )) {

      $( '.slide:first-child' ).addClass( 'active' );

      var slider = new TimelineMax({ repeat: -1 });

      var rightWidth = window.innerWidth >= 767 ? '-50%' : '-100%';
      var leftWidth = window.innerWidth >= 767 ? '200%' : '100%';

      function clipTextResize() {
        window.innerWidth >= 767 ? $( '.clipping-text' ).attr( 'x', '0%' ) : $( '.clipping-text' ).attr( 'x', '11%' );
        window.innerWidth >= 767 ? $( '.clipping-text-indent' ).attr( 'x', '5%' ) : $( '.clipping-text-indent' ).attr( 'x', '16%' );
      }

      clipTextResize();

      function desktopSlider(){

        $('text.text').removeAttr('style').removeAttr('transform');

        function nextSlide() {
          if ( $( '.slide.active' ).is( ':last-child' )) {
          $( '.slide.active' ).removeClass( 'active' );
          $( '.slide:first-child' ).addClass( 'active' );
          new TimelineMax()
            .set( $( '.slide .right' ), { right: '100%' })
            .set( $( '.slide .right .inner' ), { left: '200%' })
            .to( $( '.active .right' ), 0.75, { right: '0%', ease: Expo.easeOut })
            .to( $( '.active .right .inner' ), 0.75, { left: '0%', ease: Expo.easeOut }, '-=0.75' )
            .to( $( '.active .right' ), 0.75, { right: '-50%', delay: 3, ease: Expo.easeIn })
            .to( $( '.active .right .inner' ), 0.75, { left: '-100%', ease: Expo.easeIn }, '-=0.75' );
        } else {
          $( '.slide.active' ).removeClass( 'active' ).next().addClass( 'active' );
          new TimelineMax()
            .set( $( '.slide .right' ), { right: '100%' })
            .set( $( '.slide .right .inner' ), { left: '200%' })
            .to( $( '.active .right' ), 0.75, { right: '0%', ease: Expo.easeOut })
            .to( $( '.active .right .inner' ), 0.75, { left: '0%', ease: Expo.easeOut }, '-=0.75' )
            .to( $( '.active .right' ), 0.75, { right: '-50%', delay: 3, ease: Expo.easeIn })
            .to( $( '.active .right .inner' ), 0.75, { left: '-100%', ease: Expo.easeIn }, '-=0.75' );
          }
        }
        slider
          .set( $( '.slide .right' ), { right: '100%' })
          .set( $( '.slide .right .inner' ), { left: '200%' })
          .to( $( '.active .right' ), 0.75, { right: '0%', ease: Expo.easeOut })
          .to( $( '.active .right .inner' ), 0.75, { left: '0%', ease: Expo.easeOut }, '-=0.75' )
          .to( $( '.active .right' ), 0.75, { right: '-50%', delay: 3, ease: Expo.easeIn })
          .to( $( '.active .right .inner' ), 0.75, { left: '-100%', ease: Expo.easeIn }, '-=0.75' )
          .add( nextSlide );
      }

      function mobileSlider() {
        function nextSlide(){
          if ($('.slide.active').is(':last-child')){
            
            $('.slide.active').removeClass('active');
            $('.slide:first-child').addClass('active');
            new TimelineMax()
              .set('h2.text',{x:'-350'})
              .to('h2.text',0.5,{x:'0',ease:Power4.easeOut})
              .to('h2.text',0.5,{x:'350',ease:Power4.easeIn},3)
              .set('h2.text',{x:'-350'});
          
          } else {
          
            $('.slide.active').removeClass('active').next().addClass('active');
            new TimelineMax()
              .set('h2.text',{x:'-350'})
              .to('h2.text',0.5,{x:'0',ease:Power4.easeOut})
              .to('h2.text',0.5,{x:'350',ease:Power4.easeIn},3)
              .set('h2.text',{x:'-350'});
          
          }
        }
        slider
          .set('h2.text',{x:'-350'})
          .to('h2.text',0.5,{x:'0',ease:Power4.easeOut})
          .to('h2.text',0.5,{x:'350',ease:Power4.easeIn},3)
          .set('h2.text',{x:'-350'})
          .add(nextSlide);
      }

      function sliderCheck() {
        if (window.innerWidth >= 767){
          desktopSlider();
        } else {
          
          mobileSlider();

        }
      }
      sliderCheck();

      var isMobile = false;

      if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test( navigator.userAgent )
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( navigator.userAgent.substr( 0, 4 ))) {
          isMobile = true;
      }

      $( document ).on(function( e ) {

        var vHeight = $( '.hero' ).data( 'height' );

        if ( window.innerWidth < 767 ) {
          $( '.hero, .slide' ).removeAttr( 'style' ).css( 'height', '55vw' );
          setTimeout( function() {
            $( '.hero, .slide' ).removeAttr( 'style' ).css( 'height', '55vw' );
          }, 300 );
        }

        if ( isMobile && window.innerWidth > 767 ) {
          $( '.hero, .slide' ).removeAttr( 'style' ).css( 'height', '125vw' );
          setTimeout( function() {
            $( '.hero, .slide' ).removeAttr( 'style' ).css( 'height', '125vw' );
          }, 300 );
        }

      });

      var rWidth = $( window ).width();

      var resizeSlider;

      $( window ).resize( function() {
        if ( $( this ).width() != rWidth && !isMobile ) {

          rWidth = $( this ).width();
          window.innerWidth > 767 ? $( '.hero' ).attr( 'data-init-height', '53vw' ).height( '53vw' ) : $( '.hero' ).attr( 'data-init-height', '125vw' ).height( '125vw' );
          window.innerWidth > 767 ? $( '.slide' ).height( '53vw' ) : $( '.slide' ).height( '125vw' );
          sliderCheck();
          clipTextResize();

        }

        if( window.innerWidth > 767 ){
          $('text.text').removeAttr('style');
          $('text.text').removeAttr('transform');
        }

      });

      function watchVideo() {
        new TimelineMax()
          .to( $( '.active .right' ), 0.75, { right: rightWidth, ease: Expo.easeIn })
          .to( $( '.active .right .inner' ), 0.75, { left: '-100%', ease: Expo.easeIn }, '-=0.75' );
      }

      var iframeHome = document.querySelector( '.full-video' );
      if(iframeHome) {
        var playerHome = new Vimeo.Player( iframeHome );

        playerHome.on( 'play', function() {

          $( '.close-modal' ).hide().removeClass( 'opened' );
        });

        playerHome.on( 'pause', function() {
          $( '.close-modal' ).show().addClass( 'opened' );
        });

        $( '.video-modal' ).on('click touchend', function() {

          var promise = playerHome.play();

          if (promise !== undefined) {
            promise.then( function() {
              playerHome.pause();
            }).catch(function (error) {
              // Autoplay was prevented.
              // Show a "Play" button so that user can start playback.
            });
          
            function tweenDataHeight() {
              new TimelineMax()
                .set( $( '.full-video' ), { visibility: 'visible' })
                .to( $( '.full-video' ), 0.35, { opacity: 1 })
                .to( $( '.close-modal' ), 0.35, { opacity: 1 }, '-=0.35' ); 
            }
            
            tweenDataHeight();
         

          } else {
    
          function tweenDataHeight() {
            var dataHeight = $( '.hero' ).data( 'height' );
            new TimelineMax()
              .set( '.slide', { height: '100%' })
              .to( $( '.hero' ), 0.35, { height: dataHeight, ease: Linear.easeInOut })
              .set( $( '.full-video' ), { visibility: 'visible' })
              .to( $( '.full-video' ), 0.35, { opacity: 1 })
              .to( $( '.close-modal' ), 0.35, { opacity: 1 }, '-=0.35' );
    
            $( 'html,body' ).animate({ scrollTop: $( '.hero' ).offset().top }, 400 );
          }
    
          slider.pause();
    
          new TimelineMax()
            .add( function() {
              var dataSrc = $( '.active .full-video' ).data( 'src' );
              $( '.active .full-video' ).attr( 'src', dataSrc );
              var vWidth, vHeight;
              var iframe = document.querySelector( '.full-video' );
              var player = new Vimeo.Player( iframe );
              player.on( 'ended', function() {
                $( '.close-modal' ).trigger( 'click' );
              });
            })
            .to( $( '.active .right' ), 0.5, { right: rightWidth, ease: Expo.easeIn })
            .to( $( '.active .right .inner' ), 0.5, { left: '-100%', ease: Expo.easeIn }, '-=0.5' )
            .add( function(){
              tweenDataHeight();
            });
          }
    
          $('.full-video').addClass( 'opened' );
    
        });
      

        $( '.close-modal' ).click( function() {

          var iframe = document.querySelector( '.full-video' );
          var player = new Vimeo.Player( iframe );
          player.pause();
    
          function rollBackDataHeight() {
    
            $( window ).width() > 767 ? $( '.hero' ).attr( 'data-init-height', '53vw' ) : $( '.hero' ).attr( 'data-init-height', '125vw' );
    
            var dataHeight = $( '.hero' ).data( 'init-height' );
            new TimelineMax()
              .to( $( '.hero' ), 0.35, { height: dataHeight, ease: Linear.easeInOut })
              .to( $( '.close-modal' ), 0.35, { opacity: 0 }, '-=0.35' );
          }
    
          new TimelineMax()
            .add( function() {
              if ( window.innerWidth <= 767 ) {
                $( '.slide' ).css( 'height', '125vw' );
              }
            })
            .to( $( '.full-video' ), 0.25, { opacity: 0 })
            .add( function() {
              rollBackDataHeight();
            })
            .set( $( '.full-video' ), { visibility: 'hidden' })
            .to( $( '.active .right .inner' ), 0.5, { left: '0%', ease: Expo.easeIn })
            .to( $( '.active .right' ), 0.5, { right: '0%', ease: Expo.easeIn }, '-=0.5' );
    
            $( 'html,body' ).animate({ scrollTop: 0 }, 400 );
    
            slider.play();
    
            $('.full-video').removeClass( 'opened' );
            $( '.close-modal' ).hide().removeClass( 'opened' );
    
        });
      }

    } // ifBodyHasClassHomepage

  } //init

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();